import { t } from 'i18next'

import { Badge } from '~/components/UI/Badge'
import { getRetailMediaAccountType } from '~/helpers'

import ToggleActiveAdditionalKeyword from '../../../ToggleActiveAdditionalKeyword'

const renderSwitch = {
  active: {
    title: '',
    render: (rowData: CampaignKeyword) => (
      <ToggleActiveAdditionalKeyword data={rowData} key={rowData.id} />
    ),
    width: 50
  }
}

export const getSchemaKeywords = ({
  negative,
  addButton
}: {
  negative: boolean
  addButton: React.ReactNode
}) => {
  const accountType = getRetailMediaAccountType()
  return {
    ...(accountType === 'advertiser' ? { ...renderSwitch } : {}),
    title: {
      title: ({ total }: { total: number }) => {
        return (
          <div className="mainInfo d-flex w-100 justify-content-between align-items-center">
            <div>
              {!negative
                ? t('rm:additional_keywords')
                : t('rm:negative_keywords')}{' '}
              <small className="fw-light">
                ({Number(total) > 100000 ? '+99.999' : total}{' '}
                {total > 1 ? 'itens' : 'item'})
              </small>
            </div>
            {addButton}
          </div>
        )
      },
      render: rowData => {
        const isPaused = accountType === 'publisher' && !!rowData.disabled_at

        return (
          <>
            <span
              style={
                isPaused ? { color: 'var(--sl-fg-base-disabled)' } : undefined
              }
            >
              {rowData.keyword}
            </span>
            {isPaused && (
              <>
                {' '}
                <Badge template="warning">
                  {t('c:capitalize', {
                    value: t('rm:paused', { context: 'female' })
                  })}
                </Badge>
              </>
            )}
          </>
        )
      },
      className: 'order__details col__infos col__title',
      showTotal: true
    }
  }
}
